import React from 'react';
import { Button } from 'reactstrap';

import history from '../../utils/history';

function padLeft(nr, n, str) {
  return Array(n - String(nr).length + 1).join(str || '0') + nr;
}

class HeaderFixed extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  exitExam = () => {
    // history.push('/app/dashboard');
    this.props.handleModalStatus();
  };

  render() {
    return (
      <div className="header-exam d-flex flex-row justify-content-between">
        <div className="smallTimer d-flex flex-md-row flex-column">
          <span className="time">
            <i className="icon-clock" />
            {this.props.time}
          </span>
          <div className="title" data-test="practice-exam-questions-number">
            {' '}
            Questions {this.props.start ? this.props.start : '1'}-
            {this.props.end} of {this.props.total}
          </div>
        </div>

        <Button
          onClick={this.props.reviewMode ? this.props.exit : this.exitExam}
          color="link"
          className="btn-call-to-action exitExam"
          data-test="exit-exam-button"
        >
          EXIT EXAM
        </Button>
      </div>
    );
  }
}

export default HeaderFixed;
